import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const IntellectualPropertySection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Intellectual Property Rights</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground leading-relaxed">
        SocialScoop and its original content, features, functionality, and technology are exclusively owned by 
        SocialScoop.ai and are protected by United States and international copyright, trademark, patent, 
        trade secret, and other intellectual property or proprietary rights laws.
      </p>
    </CardContent>
  </Card>
);

export const LimitationLiabilitySection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Limitation of Liability</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        <div>
          <h4 className="font-semibold text-foreground mb-2">Service Provided "As-Is"</h4>
          <p>
            SocialScoop is provided on an "as-is" and "as-available" basis. We make no warranties, expressed or 
            implied, regarding the completeness, accuracy, or effectiveness of our content filtering service.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold text-foreground mb-2">No Guarantee of Complete Protection</h4>
          <p>
            We specifically disclaim any warranty that our service will block all unwanted content or prevent all 
            negative social media experiences. Users acknowledge that some harmful or unwanted content may bypass 
            our filtering systems.
          </p>
        </div>
        
        <div>
          <h4 className="font-semibold text-foreground mb-2">Limitation of Damages</h4>
          <p className="mb-3">
            To the maximum extent permitted by law, SocialScoop and its officers, directors, employees, and agents 
            shall not be liable for:
          </p>
          
          <ul className="list-disc list-inside space-y-2 ml-4 text-sm">
            <li>Any indirect, incidental, special, consequential, or punitive damages</li>
            <li>Any loss of profits, revenues, data, or business opportunities</li>
            <li>Any emotional distress or psychological harm from content that bypasses our filters</li>
            <li>Any damages resulting from third-party social media platform changes or outages</li>
            <li>Any harm resulting from filtered content that you would have preferred to see</li>
          </ul>
        </div>
        
        <p className="text-sm">
          Our total liability for any claims arising from or relating to this agreement shall not exceed the amount 
          you paid us in the twelve months preceding the claim, or $100, whichever is greater.
        </p>
        
        <div className="mt-4 p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-destructive text-sm">
            <strong>Important Notice:</strong> Some jurisdictions do not allow the exclusion of certain warranties or 
            limitation of liability for incidental or consequential damages. In such jurisdictions, our liability 
            shall be limited to the maximum extent permitted by law.
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const TerminationSection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Account Termination</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        <div>
          <h4 className="font-semibold text-foreground mb-2">Termination by SocialScoop</h4>
          <p>
            We may terminate or suspend your account and access to the Service immediately, without prior notice, 
            for conduct that we believe violates these Terms or is harmful to other users, us, or third parties.
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-foreground mb-2">Termination by You</h4>
          <p>
            You may terminate your account at any time by contacting us at legal@socialscoop.ai or using the 
            account deletion features available in your dashboard settings.
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);

export const ChangesToTermsSection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Modifications to Terms</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground leading-relaxed">
        We reserve the right to modify these Terms at any time. We will notify users of significant changes 
        via email or through in-app notifications. Your continued use of the Service after such modifications 
        constitutes acceptance of the updated Terms.
      </p>
    </CardContent>
  </Card>
);

export const GoverningLawSection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Governing Law & Jurisdiction</CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground leading-relaxed">
        These Terms shall be governed by and construed in accordance with the laws of the State of Delaware, 
        United States, without regard to its conflict of law principles. Any disputes arising under these 
        Terms shall be subject to the exclusive jurisdiction of the state and federal courts located in Delaware.
      </p>
    </CardContent>
  </Card>
);

export const ContactInformationSection = () => (
  <Card className="border-border/50 shadow-sm">
    <CardHeader>
      <CardTitle className="text-foreground text-xl font-semibold">Contact Information</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3 text-muted-foreground leading-relaxed">
        <p>
          If you have any questions about these Terms of Service, please contact us:
        </p>
        <div className="space-y-2">
          <p>
            <span className="font-medium text-foreground">Email:</span>{' '}
            <a href="mailto:legal@socialscoop.ai" className="text-primary hover:underline transition-colors">
              legal@socialscoop.ai
            </a>
          </p>
          <p>
            <span className="font-medium text-foreground">Website:</span>{' '}
            <a href="https://socialscoop.ai" className="text-primary hover:underline transition-colors">
              socialscoop.ai
            </a>
          </p>
        </div>
      </div>
    </CardContent>
  </Card>
);
